import ClipText from "@components/ClipText/ClipText";
import Image from "@components/Image";
import Link from "@components/Link";
import cx from "classnames";
import React from "react";
import styles from "./Spotlight.module.scss";
import Button from "@components/Button";
import { useRouteContext } from "@providers/RouteProvider";
import _ from "lodash";
interface Props {
  data: {
    image: {
      src: string;
      alt: string;
    };
    title: string;
    content: string | React.ReactNode;
    actionMore: string | React.ReactNode;
    button: {
      label: string;
      href: string;
    };
    slug: string;
  };
}

export default function Item({ data }: Props) {
  const { router } = useRouteContext();
  return (
    <Link href={router.toUrl("storiesArticle", { slug: data.slug })}>
      <div className={cx(styles.item)}>
        <Image
          {..._.get(data, "image")}
          alt={_.get(data, "image.alt") || data.title || "Spotlight image"}
          wrapperProps={{ className: cx(styles.image) }}
          layout="fill"
          objectFit="cover"
        />
        <ClipText fixedRows rows={1} className={cx(styles.title)}>
          {data.title}
        </ClipText>
        <ClipText fixedRows rows={5} className={cx(styles.content)}>
          {data.content}
        </ClipText>
        <Button
          type="icon"
          suffix="shape-arrow"
          className={cx(styles.actionMore, "mt-auto")}
          label={_.get(data, "button.label")}
          onClick={() => {
            location.href = _.get(data, "button.href");
          }}
        />
      </div>
    </Link>
  );
}
